module.exports = __webpack_public_path__ + "panel/img/female.2a17c58e.png";